import {
  isWeekend,
  addMonths,
  lastDayOfMonth,
  addDays,
  subDays,
  isSaturday,
  setDate,
  getDate,
  min,
} from 'date-fns'

const rollingConvention = {
  START: 1,
  END: 2,
}

function getConvention(startDate) {
  const rollingDay = getDate(startDate)
  if (rollingDay <= 5) {
    return rollingConvention.START
  } else {
    return rollingConvention.END
  }
}

function fridayIfWeekend(date) {
  if (isWeekend(date)) {
    return subDays(date, isSaturday(date) ? 1 : 2)
  }
  return date
}

function mondayIfWeekend(date) {
  if (isWeekend(date)) {
    return addDays(date, isSaturday(date) ? 2 : 1)
  }
  return date
}

function getEndDate(date) {
  return fridayIfWeekend(lastDayOfMonth(date))
}

function getStartDate(startDate, months, convention) {
  if (months === 0) return startDate

  const nextDate = addMonths(startDate, months)
  if (convention == rollingConvention.START) {
    return mondayIfWeekend(setDate(nextDate, 1))
  }

  return nextDate
}

function dateRangeWeek(startDate, endDate) {
  if (startDate > endDate) return
  let d = startDate

  const dates = []
  while (d <= endDate) {
    dates.push({
      startDate: d,
      endDate: d,
    })
    let end = addDays(d, 7)
    d = end
  }

  return dates
}

export {mondayIfWeekend, fridayIfWeekend, dateRangeWeek}

export default function dateRange(startDate, endDate) {
  if (startDate > endDate) return
  let d = startDate,
    month = 0,
    convention = getConvention(startDate)

  const dates = []
  while (d < endDate) {
    d = getStartDate(startDate, month, convention)
    month++
    const end = min(getEndDate(d), endDate)
    if (d > endDate) break
    dates.push({
      startDate: convention === rollingConvention.END ? end : d,
      endDate: end,
    })
  }

  return dates
}
